/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EditConfirmationRequest
 */
export interface EditConfirmationRequest {
    /**
     * The Gondola-internal numeric booking id (as a string).
     * @type {string}
     * @memberof EditConfirmationRequest
     */
    bookingId: string;
    /**
     * The corrected supplier confirmation (provider booking) number.
     * @type {string}
     * @memberof EditConfirmationRequest
     */
    confirmationNumber: string;
}

/**
 * Check if a given object implements the EditConfirmationRequest interface.
 */
export function instanceOfEditConfirmationRequest(value: object): value is EditConfirmationRequest {
    if (!('bookingId' in value) || value['bookingId'] === undefined) return false;
    if (!('confirmationNumber' in value) || value['confirmationNumber'] === undefined) return false;
    return true;
}

export function EditConfirmationRequestFromJSON(json: any): EditConfirmationRequest {
    return EditConfirmationRequestFromJSONTyped(json, false);
}

export function EditConfirmationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): EditConfirmationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'bookingId': json['booking_id'],
        'confirmationNumber': json['confirmation_number'],
    };
}

export function EditConfirmationRequestToJSON(json: any): EditConfirmationRequest {
    return EditConfirmationRequestToJSONTyped(json, false);
}

export function EditConfirmationRequestToJSONTyped(value?: EditConfirmationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'booking_id': value['bookingId'],
        'confirmation_number': value['confirmationNumber'],
    };
}

